/* eslint-disable */
export const downloadFile = (data, name) => {
  const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
  const fileName = `${name}.csv`;
  // Fix for IE11
  const url = navigator.msSaveBlob
    ? navigator.msSaveBlob(blob, fileName)
    : window.URL.createObjectURL(blob);
  const element = document.createElement('a');
  element.href = url;
  element.download = `${name}.csv`;
  // element.setAttribute('download', fileName);
  // Need to append the element again for firefox and IE
  document.body.appendChild(element);
  element.click();
  element.remove();
};
